import React from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import { parseFieldArea } from "utils";
import Loading from "components/Loading";
import "./index.scss";

const encodeObject = (object) => {
  return encodeURIComponent(JSON.stringify(object))
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");
};

const Fields = ({ loading, fields }) => {
  const mapUrl = (field) => {
    const baseUrl =
      "https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static";
    const geojson = {
      type: "Feature",
      properties: {
        stroke: "#09BA51",
        "stroke-width": 2,
        "stroke-opacity": 1.0,
      },
      geometry: field.geometry,
    };
    const bBox = field.bbox;
    const mapStyle = "100x100@2x?padding=8";
    const mapboxToken = process.env.REACT_APP_MAPGL_ACCESS_TOKEN;

    return `${baseUrl}/geojson(${encodeObject(
      geojson
    )})/[${bBox}]/${mapStyle}&access_token=${mapboxToken}`;
  };

  const renderContent = () => {
    if (loading) {
      return (
        <tr data-testid="loading" className="fields-loading">
          <td colSpan={4} style={{ textAlign: "center" }}>
            <Loading uniqueKey="farm-fields" />
          </td>
        </tr>
      );
    }

    return fields.map((field) => (
      <tr key={field.id} className="field-body">
        <td />
        <td className="field details">
          <img className="field-image" src={mapUrl(field)} alt="field-map" />
          <span>{field.properties.field_name}</span>
        </td>
        <td className="field">
          {field.properties?.field_crop_type === ""
            ? "Select Crop Type"
            : field.properties?.field_crop_type}
        </td>
        <td className="field">{parseFieldArea(field.properties.area)} Ha</td>
        <td className="field" colSpan={2}>
          {format(new Date(field.properties.updated_on), "MMMM d, yyyy")}
        </td>
      </tr>
    ));
  };

  return (
    <tr className="fields-dashboard" data-testid="fields">
      <td colSpan={6}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr className="fields-header">
              <td />
              <td className="field">Field</td>
              <td className="field">Crop Type</td>
              <td className="field">Area</td>
              <td className="field" colSpan={2}>
                Last Update
              </td>
            </tr>
            {renderContent()}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

Fields.propTypes = {
  loading: PropTypes.bool.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      properties: PropTypes.shape({
        field_name: PropTypes.string.isRequired,
        field_crop_type: PropTypes.string.isRequired,
        area: PropTypes.number.isRequired,
        updated_on: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
};

export default Fields;
